export default __webpack_public_path__ + "static/media/8.611b3fb2.jpg";